<template>
  <base-input type="email" label="Sähköpostiosoite" v-bind="$attrs">
    <template #left>
      <mail-icon size="1.5x" class="field-icon" aria-hidden />
    </template>
  </base-input>
</template>

<script>
import { MailIcon } from '@bit/vekenkaluste.veke-ui.icons'
import BaseInput from '@bit/vekenkaluste.veke-ui.input'

export default {
  name: 'EmailField',
  components: { BaseInput, MailIcon },
  inheritAttrs: false,
}
</script>
